import React, {Fragment} from 'react';
import ImageSlider from './../components/Image_slider';

const MainStatements = (props) => {
    return (
    <Fragment>
        <div className="flex lg:justify-center" id="home_quotes">
            <div className="break-none col-span-1 xl:text-left lg:text-center md:text-center sm:text-center">
                <h2 className="anton font-bold text-3xl text-blue-900 xl:mt-32" id="slider_title">{props.h2}</h2>
                <h3 className="text-4xl py-3 font-medium">{props.h3}</h3>
                <h4 className="text-lg font-medium">{props.h4}</h4>
                <div className="border-b border-gray-500 pt-3"></div>
            </div>
        </div>
        <div className="xl:w-full xl:pl-10 xl:col-span-2 lg:flex lg:justify-center lg:pt-5" id="image_slider">
            <ImageSlider slides={props.data}/>
        </div>
    </Fragment>
    )
}

export default MainStatements
